<template>
  <div class="container">
    <div class="box-title" :style="{marginTop: '10px'}">
      <h4 style="margin-top: -10px;">
        <i class="fal fa-gifts"></i>
        ລາຍການທັງໝົດ
        <span class="countTotal">({{ count }})</span>
        <span class="btn-add">
                    <vs-button :style="{marginTop: '-10px'}"
                               ref="button" flat
                               @click="AddInvoices()"
                               class="form-btn-loading"
                               :loading="loading"
                               :disabled="!isSelectingOrders"
                    >
                        ສ້າງ Invoices
                    </vs-button>
                </span>
      </h4>
    </div>

    <div class="box" :style="{marginTop: '-10px'}">
      <div class="columns">
        <div class="column is-3">
          <div class="field">
            <div class="control">
              <label class="label">ເລກທີບິນ:</label>
              <input
                  class="input"
                  placeholder="ເລກທີບິນ..."
                  type="text" name="shipment_number"
                  v-model="shipment_number"
                  @keyup.enter="FilterShipmentNumber()"
              >
            </div>
          </div>
        </div>
        <div class="column is-3">
          <div class="control">
            <label class="label">ເເຕ່ວັນທີ</label>
            <date-picker
                format="DD/MM/YYYY HH:mm"
                value-type="YYYY-MM-DD HH:mm"
                type="datetime"
                v-model="startDate"
                :disabled-date="disabledAfterToday"
                v-validate="'required'"
                :clearable="false"
                name="valid_date"
            ></date-picker>
          </div>
        </div>
        <div class="column is-3">
          <div class="control">
            <label class="label">ຫາວັນທີ</label>
            <date-picker
                format="DD/MM/YYYY HH:mm"
                value-type="YYYY-MM-DD HH:mm"
                type="datetime"
                v-model="endDate"
                :disabled-date="disabledAfterToday"
                v-validate="'required'"
                :clearable="false"
                name="valid_date"
            ></date-picker>
          </div>
        </div>
        <div class="column is-3">
          <div class="control">
            <label class="label">ຊື່ລູກຄ້າ:</label>
            <model-list-select
                :list="companyCustomer"
                v-model="selectedCompanyCustomer"
                placeholder="ຊື່ລູກຄ້າ"
                option-text="name"
                option-value="id"
                selectedItem="name">
            </model-list-select>
          </div>
        </div>
      </div>
    </div>

    <div class="center table-limit-height" style="margin-top: -15px;">
      <vs-table v-model="pageInvoices" ref="table">
        <template #thead>
          <vs-tr>
            <vs-th>
              <div class="center">
                <vs-checkbox danger
                             @click="onCheckAllCheckBoxChanged"
                             :value="isIndeterminate || isSelectAllOrders"
                             :loading="isSelecting"
                             :checked-force="isSelectAllOrders"
                             :indeterminate="isIndeterminate">
                  <span :style="{fontSize: '16px', marginLeft: '8px'}">ທັງໝົດ</span>
                </vs-checkbox>
              </div>
            </vs-th>
            <vs-th>ເລກທີບິນ</vs-th>
            <vs-th>ວັນທີຈ່າຍ</vs-th>
            <vs-th>ຄ່າຂົນສົ່ງ</vs-th>
            <vs-th>ສາຂາຕົ້ນທາງ</vs-th>
            <vs-th>ສາຂາປາຍທາງ</vs-th>
            <vs-th>ຊື່ລູກຄ້າ</vs-th>
            <vs-th>ຜູ້ຮັບຜິດຊອບ</vs-th>
            <!-- <vs-th></vs-th> -->
          </vs-tr>
        </template>
        <template #tbody>
          <vs-tr
              v-for="(item, index) in invoices"
              :key="index"
              :is-selected="isRowSelected(item.id)"
              :data="item"
              @selected="onItemCheckBoxChanged(item)"
          >
            <vs-td>
              <div class="center con-checkbox">
                <vs-checkbox danger
                             :checked-force="isRowSelected(item.id)"
                             :val="item" @click="onItemCheckBoxChanged(item)">
                  <span :style="{fontSize: '16px', marginLeft: '10px'}">{{ index + 1 }}</span>
                </vs-checkbox>
              </div>
            </vs-td>
            <vs-td :style="{color: 'crimson'}">( {{ item.shipment_number }} )</vs-td>
            <vs-td>{{ FormatDate(item.paid_at) }}</vs-td>
            <vs-td>( {{ FormatPrice(item.paid) }} )</vs-td>
            <vs-td>{{ item.start_branch }}</vs-td>
            <vs-td>{{ item.end_branch }}</vs-td>
            <vs-td>{{ item.sender_name }}</vs-td>
            <vs-td>{{ item.created_by }}</vs-td>
            <!-- <vs-td style="text-align: right; width: 100px">
                <div class="group-icon">
                    <vs-button circle icon flat @click="$router.push({name: 'list.shipment.detail', params:{id: item.id}})">
                        <i class="fad fa-eye"></i>
                    </vs-button>
                </div>
            </vs-td>   -->
          </vs-tr>
        </template>
        <template #footer>
          <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="offset"
                      @paginate="FetchData"></pagination>
          <Loading v-if="isLoading"/>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>

import Loading from '../../Loading';
import MixinShipmentCompany from '../../../Mixins/Shipments/Company/List-Shipment';
import DatePicker from "vue2-datepicker";
import pagination from '../../../Plugins/Paginations/Pagination';
import {ModelListSelect} from 'vue-search-select';

export default {
  components: {
    Loading,
    DatePicker,
    pagination,
    ModelListSelect
  },

  mixins: [MixinShipmentCompany],

  created() {
    this.FetchCompanyCustomer();
    this.FetchData();
  },
}
</script>

<style lang="scss">
.btn-clear {
  background: $crimson;

  &:hover {
    color: $white;
  }
}

.vs-select__input {
  width: 55% !important;
  margin-left: -163px !important;
  border-radius: 5px !important;
  background: $white !important;
  border: 1px solid rgba(173, 172, 172, 0.562) !important;
}
</style>
